import React from "react";
import { Children } from "./constant";
import ScrollWrapper from "../../common/components/ScrollBar";

const ProcessesContainer = ({ location, isSideNav }) => {
  const getActivePath = (path) => {
    const paths = path.split("/");
    if (paths.length) {
      return paths[paths.length - 1];
    }
    return "";
  };

  const activePath = getActivePath(location?.pathname);
  const ActiveContent = Children[activePath];

  if (!ActiveContent) {
    return null;
  }

  return (
    <div className={`clinicWorkflow__main ${isSideNav ? "" : "collapsed"}`}>
      <ScrollWrapper css="no-padding x-hidden">
        <ActiveContent />
      </ScrollWrapper>
    </div>
  );
};

export default ProcessesContainer;
